import React, { useState } from "react";

import { GetMenuItemsAvailableFilters } from "@/api/requests/getMenuItems";

import {
  MenuFilterMap,
  MenuFiltersGroup,
  MenuFiltersToggle,
  MenuPage,
} from "../../types/MenuFilters";
import FilterGroups from "./FilterGroups";

const MenuFilterGroups: React.FC<{
  menuFilterMap?: MenuFilterMap;
  defaultOpenKey: string | undefined;
  availableFilters: GetMenuItemsAvailableFilters;
  menuPage: MenuPage;
  loading?: boolean;
}> = ({
  availableFilters,
  menuFilterMap,
  defaultOpenKey,
  menuPage,
  loading,
}) => {
  const [lastClickedFilterName, setLastClickedFilterName] = useState<string>();
  const handleFilterClick = (filterName: string, _filterOption: string) => {
    setLastClickedFilterName(filterName);
  };

  return (
    <>
      {availableFilters &&
        menuFilterMap &&
        availableFilters.map((filter) => (
          <FilterGroups
            filters={filter as MenuFiltersGroup | MenuFiltersToggle}
            key={filter.name + Math.random().toString()}
            menuFilterMap={menuFilterMap}
            defaultOpenKey={defaultOpenKey || lastClickedFilterName}
            menuPage={menuPage}
            loading={loading}
            handleFilterClick={handleFilterClick}
          />
        ))}
    </>
  );
};

export default MenuFilterGroups;
